import { PayloadAction } from "@reduxjs/toolkit";
import { InitialState, OptOutFields, ParentOptOutModes } from "./Types";

/**
 * To set the selected optOuts
 * @param state Initial state
 * @param action Payload
 */
export const Reducer = {
  updateSelectedOptOuts: (state: InitialState, action: PayloadAction<OptOutFields>): void => {
    const currentValues = [...state.selectedOptOuts];
    if (action.payload.checked) {
      if (currentValues.includes(action.payload.value)) return;
      state.selectedOptOuts = [...currentValues, action.payload.value];
    } else {
      const unCheckedOptOutFields = currentValues.filter((item: string) => (item !== action.payload.value));
      state.selectedOptOuts = unCheckedOptOutFields;
    }
  },

  /**
   * To set the optOut list
   * @param state Initial state
   * @param action Payload
   */
  setOptOutList: (state: InitialState, action: PayloadAction<string[]>): void => {
    state.selectedOptOuts = action.payload;
  },

  /**
   * To set the optOut mode
   * @param state Initial state
   * @param action Payload
   */
  setOptOutMode: (state: InitialState, action: PayloadAction<ParentOptOutModes>): void => {
    state.mode = action.payload;
  }
};
